<script setup lang="ts">
import { ref } from 'vue'
import { CanvasRenderer } from 'echarts/renderers'
import { graphic, use } from 'echarts/core'
import { BarChart, LineChart } from 'echarts/charts'
import VChart from 'vue-echarts'

import {
  GridComponent,
  ToolboxComponent,
  TooltipComponent,
} from 'echarts/components'
import { useQuery } from '@tanstack/vue-query'
import { todayNearest } from '@mp/api/mchTradeData/BpIndexDashboardController.js'

use([
  GridComponent,
  CanvasRenderer,
  LineChart,
  BarChart,
  TooltipComponent,
  ToolboxComponent,
])

const chartRef = ref<InstanceType<typeof VChart> | null>(null)
const option = ref({
  tooltip: {
    trigger: 'axis',
  },
  grid: {
    top: 10,
    left: 0,
    right: 0,
    bottom: 0,
    containLabel: true,
  },
  yAxis: [
    {
      type: 'value',
      name: '活跃门店',
      position: 'left',
      splitLine: {
        lineStyle: {
          color: '#eee',
          type: 'dashed',
        },
      },
      minInterval: 1,
    },
  ],
  xAxis: [
    {
      type: 'category',
      data: [] as string[],
      axisLabel: {
        color: '#999',
        fontSize: 10,
      },
      axisLine: {
        lineStyle: {
          color: '#eee',
        },
      },
    },
  ],
  series: [{
    name: '活跃门店',
    type: 'line',
    smooth: true,
    lineStyle: {
      width: 3,
      color: '#84DFAD',
    },
    showSymbol: false,
    symbolSize: 10,
    itemStyle: {
      color: '#84DFAD',
    },
    areaStyle: {
      opacity: 0.8,
      color: new graphic.LinearGradient(0, 0, 0, 1, [
        {
          offset: 0,
          color: '#84DFAD',
        },
        {
          offset: 1,
          color: 'rgba(255,255,255,1)',
        },
      ]),
    },
    emphasis: {
      focus: 'series',
    },
    data: [] as number[],
  }],
})

const { isLoading } = useQuery({
  queryKey: ['day/stat/trade/specifyDate/businessTrend'],
  queryFn: () => todayNearest({}),
  select(data) {
    const rows = data?.rows || []
    option.value.xAxis[0].data = rows?.map(item => item.dateTime || '')
    option.value.series[0].data = rows?.map(item => item.activeShopCount || 0)
    return rows
  },
})
</script>

<template>
  <VChart ref="chartRef" autoresize :loading="isLoading" class="h-[300px] mt-6" :option="option" />
</template>
